import {
  LocalStorageConsts,
} from 'client/util/Constants';
import LocalStorageService from 'client/util/LocalStorageService';
import store from 'client/store';

const settingsModule = 'SettingsModule';

const { paywallAbandonedNudgeVisible } = LocalStorageConsts;

const getCurrentSessionCount = (storeInstance) => {
  const { user } = storeInstance.state[settingsModule];
  return user.sessionCount;
};

const getConfigFromLocalStorage = () => {
  const localStorageNudgeData = LocalStorageService.getItem(paywallAbandonedNudgeVisible);
  return localStorageNudgeData ? JSON.parse(localStorageNudgeData) : null;
};

const storeConfigInLocalStorage = (nudgeConfig) => {
  LocalStorageService.setItem(paywallAbandonedNudgeVisible, JSON.stringify(nudgeConfig));
};

const dismissPaywallAbandonedNudge = () => {
  const nudgeConfig = getConfigFromLocalStorage();

  if (!nudgeConfig) {
    return;
  }

  nudgeConfig.dismissed = true;
  storeConfigInLocalStorage(nudgeConfig);
};

const isNudgeVisibleForSession = (storeInstance, nudgeConfig) => {
  const sessionCountDiff = getCurrentSessionCount(storeInstance) - nudgeConfig.sessionCount;

  // display nudge in the next three sessions after it was enabled
  const isNudgeVisible = sessionCountDiff >= 1 && sessionCountDiff <= 3;

  if (!isNudgeVisible && sessionCountDiff !== 0) {
    // nudge has been displayed for three sessions, dismiss and never show again
    dismissPaywallAbandonedNudge();
  }

  return isNudgeVisible;
};

const isPaywallAbandonedNudgeVisible = (storeInstance = store) => {
  const nudgeConfig = getConfigFromLocalStorage();

  // if nudgeConfig not defined, nudge has NOT been enabled
  // if nudge is dismissed, never show again
  const isNudgeDisabledOrDismissed = !nudgeConfig || nudgeConfig.dismissed;

  return !isNudgeDisabledOrDismissed && isNudgeVisibleForSession(storeInstance, nudgeConfig);
};

const setupPaywallAbandonedNudge = (storeInstance = store) => {
  const nudgeConfig = {
    dismissed: false,
    sessionCount: getCurrentSessionCount(storeInstance),
  };

  storeConfigInLocalStorage(nudgeConfig);
};

export default {
  dismissPaywallAbandonedNudge,
  isPaywallAbandonedNudgeVisible,
  setupPaywallAbandonedNudge,
};
